import type { CSSProperties, ReactNode } from "react";
import { HomeCarouselControls, HomeFold } from "../MerchantHomePrimitives";
import { CARD_DECK_INTERVAL_MS, cardDeckDepth } from "./cardDeck";
import "./merchant-data-card.css";

/** Surface and controls remain mounted while the single live business body switches. */
export function MerchantDataCard({ className, surface, watermark, stroke, toolbar, children, count = 0 }: {
  className: string; surface: ReactNode; watermark?: ReactNode; stroke: ReactNode;
  toolbar?: ReactNode; children: ReactNode; count?: number;
}) {
  return <div className={`${className} merchant-data-card`}>
    {surface}{watermark}{children}{stroke}{toolbar}
    {Array.from({ length: cardDeckDepth(count) }, (_, index) => <div key={index} aria-hidden="true" className="merchant-data-card__layer workbench-card__stack-layer" style={{ "--workbench-stack-offset": `${index * 12}px`, "--workbench-stack-inset": `${(index + 1) * 8}px` } as CSSProperties}><HomeFold variant="banner" /></div>)}
  </div>;
}

export function CardDeckProgress({ count, current, playing, onSelect, label }: {
  count: number; current: number; playing: boolean; onSelect: (index: number) => void; label: string;
}) {
  if (count < 2) return null;
  return <div className="merchant-data-card__progress" data-playing={playing} style={{ "--card-deck-duration": `${CARD_DECK_INTERVAL_MS}ms` } as CSSProperties}>
    <HomeCarouselControls count={count} current={current} onSelect={onSelect} label={label} showArrows={false} />
  </div>;
}
